module.exports = __webpack_public_path__ + "static/media/jsFramework.d249cbdf.svg";